import { FC, useMemo } from "react";
import { Line, LineChart, ResponsiveContainer, YAxis } from "recharts";
import { v4 as uuidv4 } from 'uuid';

import { colorMap } from "../Chart/types";
import { EColor } from "../../constants/colors";
import { getMinMaxValues } from "./utils/getMinMaxValues";
import { hasOnlyOneValue } from "../Chart/utils/hasOnlyOneValue";
import { getCurrentTrendGraph } from "../Chart/utils/getCurrentTrendGraph";
import { ITrendChartProps } from "./types";



const TrendChart: FC<ITrendChartProps> = ({ score, strokeWidth = 8 }) => {
  const gradientKey = useMemo(() => uuidv4(), []);
  const { maxValue, minValue } = useMemo(() => getMinMaxValues(score), [score]);
  const isOneValue = useMemo(() => hasOnlyOneValue(score), [score]);
  const colorGraph = useMemo(() => colorMap[getCurrentTrendGraph(score)], [score]);

  return (
    <ResponsiveContainer width="100%" height={35}>
      <LineChart data={isOneValue ? [
        { ...score[0], x: 0 },
        { ...score[0], x: 1 }
      ] : score}>
        <Line
          type="monotone"
          connectNulls
          dataKey="visibility"
          stroke={`url(#${gradientKey})`}
          strokeWidth={strokeWidth}
          dot={false}
        />
        <YAxis domain={[minValue, maxValue]} hide />
        <defs>
          <linearGradient
            id={gradientKey}
            gradientUnits="userSpaceOnUse"
            x1="0%"
            x2="100%"
          >
            <stop offset="50%" stopColor={EColor.Gray3} />
            <stop offset="100%" stopColor={colorGraph} />
          </linearGradient>
        </defs>
      </LineChart>
    </ResponsiveContainer >
  );
};

export default TrendChart;
